<form class="form-container" #formRef="ngForm">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/userrole']">User Role</a> > {{ userrole.name || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" type="submit" mat-flat-button color="primary" (click)="save(formRef.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Name</mat-label>
            <input type="text" matInput name="name" [(ngModel)]="userrole.name" required #roleName="ngModel">
            <mat-error *ngIf="roleName.invalid && roleName.touched">Name is required</mat-error>
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>

  <!-- Access Control Section -->
  <div class="access-section">
    <div class="section-header">
      <h2>Module Permissions</h2>
      <div class="section-header-actions">
        <span class="summary-chip">
          <mat-icon>verified_user</mat-icon>
          {{ modules_selected.length }} of {{ modules.length }} enabled
        </span>
        <mat-checkbox
          [checked]="allSelected"
          [indeterminate]="someSelected"
          (change)="toggleAll($event)"
          [disabled]="isFormDisabled"
          color="primary">
          Toggle All
        </mat-checkbox>
      </div>
    </div>

    <div class="modules-grid">
      <div *ngFor="let mod of modules" class="module-card" [class.enabled]="isModuleEnabled(mod.name)">
        <div class="module-card-header">
          <div class="module-icon" [class.active]="isModuleEnabled(mod.name)">
            <mat-icon>{{ mod.icon }}</mat-icon>
          </div>
          <mat-slide-toggle
            [checked]="isModuleEnabled(mod.name)"
            (change)="onToggleModule(mod.name, $event)"
            [disabled]="isFormDisabled"
            color="primary">
          </mat-slide-toggle>
        </div>
        <div class="module-card-body">
          <h3>{{ mod.displayName }}</h3>
          <p>{{ mod.description }}</p>
        </div>
      </div>
    </div>
  </div>
  <app-audit-log-viewer model="userrole" [recordId]="userrole.id"></app-audit-log-viewer>
</form>
